import { useState, useEffect } from 'react'
import useIsMounted from 'ismounted'

import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import client from 'api/client'
import { SettingsMember } from 'types'
import { reportError } from 'utils/error'

import { useAuth } from './UseAuth'

interface UseWorkspaceMembersOptions {
  includeInactive: boolean
}

const defaultOptions: UseWorkspaceMembersOptions = {
  includeInactive: true,
}

export const useWorkspaceMembers = (workspaceId?: string, opts = defaultOptions) => {
  const auth = useAuth()
  const isMounted = useIsMounted()
  const [workspaceMembers, setWorkspaceMembers] = useState<SettingsMember[]>([])

  useEffect(() => {
    if (!workspaceId || !auth) return
    client.getWorkspaceMembers(workspaceId).then((res) => {
      if (!isMounted.current) {
        return
      }
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        return reportError('useWorkspaceMembers received an error response', {
          severity: 'error',
          metaData: res.data,
        })
      }

      const { members } = res.data?.data || { members: [] }
      if (opts.includeInactive) return setWorkspaceMembers(members)

      setWorkspaceMembers(members.filter((m) => m.type !== 'DeletedMembership'))
    })
  }, [workspaceId]) // eslint-disable-line react-hooks/exhaustive-deps

  return workspaceMembers
}
